module.exports = __webpack_public_path__ + "static/Club-Blu-12c7ad665229e4ba25f53a0c07acb764.jpg";